import React, { Component } from 'react';
import { connect } from 'react-redux'
import FetchData from '../../../Utils/FetchData'
import setRoleIdAction from '../../../../actions/setRoleIdAction'
import setRoleNameAction from '../../../../actions/setRoleNameAction'
import setTaskNameAction from '../../../../actions/setTaskNameAction'
import setTaskIdAction from '../../../../actions/setTaskIdAction'
import setDirectoryIdAction from '../../../../actions/setDirectoryIdAction'
import setFolderIdAction from '../../../../actions/setFolderIdAction'
import setFolderNameAction from '../../../../actions/setFolderNameAction'
import setDirectoryNameAction from '../../../../actions/setDirectoryNameAction'
import setNotificationsTasksAction from '../../../../actions/setNotificationsTasksAction'
import setFoldersNotificationsCountAction from '../../../../actions/setFoldersNotificationsCountAction'
import setActionTaskContextExpColaps from '../../../../actions/setActionTaskContextExpColaps'
import setActionTabs from '../../../../actions/setActionTabs'
import setActiondropdownFlag from '../../../../actions/setActiondropdownFlag'
import SvgUser from '../../../../iconComponents/usertextboxheaderIcon';

import '../Role/Role.css'

class Role extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.state = {
            RoleData: [],
            popupVisible: false

        }
        if (this.props.usedataState !== undefined) {
            this.fetchRoles()
        }
    }

    fetchRoles() {
        FetchData('/api/RTFCW/UserRolesA/' + this.props.usedataState)
            .then((data) => {
                this.setState({ RoleData: data.data })
            }).catch(error => {
                if (error == "TOKEN_REFRESH_EXCEPTION") {
                    alert('Your login session has expired, please log in again.')
                    window.location.href = '/';
                }
            })
    }

    changerole = e => {
        var changeRoleValues = e.split(',')
        this.props.idRoleSet(changeRoleValues[0])
        this.props.nameRoleSet(changeRoleValues[1])
        this.props.taskIdSet(undefined)
        this.props.taskNameSet(null)
        this.props.folderNameSet(null)
        this.props.folderIdSet(null)
        this.props.directoryIdSet(null)
        this.props.directoryNameSet(null)

        this.props.actionTaskContextExpandCollapse(true)
        this.props.currNotificationsFoldersSet(null)
        this.props.actionTabsSet(undefined)
        document.getElementById("myDropdownChangeRole").classList.remove("show");

    }


    handleClick() {
        if (!this.state.popupVisible) {
            //console.log('1')
            // attach/remove event handler
            document.addEventListener('click', this.handleOutsideClick, false);
        } else {
            //console.log('2')
            document.removeEventListener('click', this.handleOutsideClick, false);
        }

        this.setState(prevState => ({
            popupVisible: !prevState.popupVisible,
        }));
        //document.removeEventListener('click', this.handleClickOutsideNotification, true);
        document.getElementById("myDropdownNotification").classList.remove("show");
    }

    handleOutsideClick(e) {
        // ignore clicks on the component itself
        if (this.node.contains(e.target)) {
            return;
        }

        this.handleClick();

    }
    render() {
        var roleStyles;

        if (this.props.themeState === false || this.props.themeState === undefined) {

            roleStyles = window.defaultTheme;
        } else {

            roleStyles = window.darkTheme;
        }
        //var options = this.state.RoleData.map(Role => {
        //    if (Role.id != this.props.roledataId) {
        //        return  <option key={Role.id} value={Role.id + "," + Role.name}>{Role.name}</option>
        //    }
        //})
        let options = this.state.RoleData.map(Role => {
            if (Role.id != this.props.roledataId) {
                //return <li value={Role.id}>{Role.name}</li>
                return <li onClick={this.changerole.bind(this, + Role.id + "," + Role.name)} key={Role.id} value={Role.id}>{Role.name}</li>

            }
        })

        return (
            <div className="popover-container" ref={node => { this.node = node; }}>
                {/*<h4 className="control-sidebar-heading" style={roleStyles.rightFonts}>Current Role</h4> <br />
                <form className="login100-form validate-form" style={{ marginTop: '-2px' }}>
                    <select  style={{ fontSize: '13px' }} className="form-control select2" name={this.props.name} onChange={this.changerole.bind(this)} >
                        <option value="">{this.props.roledataName}</option>
                        {options}
                    </select>
                </form>*/}
                <div className="rowDrop">
                    <div className="icon">
                        <SvgUser />
                    </div>
                    <div className="navbar-custom-menu">
                        <ul onClick={this.handleClick} style={{}} className="roledropbtn"><h1 className='roleText' >{this.props.roledataName}</h1>  <h1 className='roleViewas' >View As</h1> </ul>
                        {this.state.popupVisible && (
                            <div id="myDropdownChangeRole" className="navbar-custom-menu-content">
                                {
                                    options
                                }

                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        roledataId: state.roleDataId,
        roledataName: state.roleDataName,
        usedataState: state.userData,
        themeState: state.currentThemeName,
        dropdownflagState: state.currDropdownflagState,
        taskIdState: state.taskDataId,

    }
};
const mapDispatchToProps = dispatch => {
    return {
        idRoleSet: payload => dispatch(setRoleIdAction(payload)),
        nameRoleSet: payload => dispatch(setRoleNameAction(payload)),
        taskNameSet: payload => dispatch(setTaskNameAction(payload)),
        taskIdSet: payload => dispatch(setTaskIdAction(payload)),
        folderNameSet: payload => dispatch(setFolderNameAction(payload)),
        folderIdSet: payload => dispatch(setFolderIdAction(payload)),
        directoryIdSet: payload => dispatch(setDirectoryIdAction(payload)),
        directoryNameSet: payload => dispatch(setDirectoryNameAction(payload)),
        currNotificationsTasksSet: payload => dispatch(setNotificationsTasksAction(payload)),
        currNotificationsFoldersSet: payload => dispatch(setFoldersNotificationsCountAction(payload)),
        actionTaskContextExpandCollapse: payload => dispatch(setActionTaskContextExpColaps(payload)),
        currDropdownflagState: payload => dispatch(setActiondropdownFlag(payload)),
        actionTabsSet: payload => dispatch(setActionTabs(payload)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Role);



// WEBPACK FOOTER //
// ./src/components/TaskView/SideDraw/Role/Role.js